<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <el-radio-group v-model="shortcutIndex" @change="confirm">
          <el-radio-button v-for="(shortcut, index) in shortcuts"
            v-bind:key="shortcut.label" :label="index">
            {{shortcut.label}}
          </el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <br>

    <el-form :model="pickers" ref="pickersForm" :rules="rules">
      <div class="row" v-if="useSplitPickers === true">
        <div class="col-xl-6">
          <el-form-item prop="dateRange">
            <el-date-picker v-model="pickers.dateRange[0]" type="datetime" :clearable="false" size="small"
              format="yyyy-MM-dd h:mmA" default-time="00:00:00"
              @change="confirm(-1)" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="col-xl-6">
          <el-form-item prop="dateRange">
            <el-date-picker v-model="pickers.dateRange[1]" type="datetime" :clearable="false" size="small"
              format="yyyy-MM-dd h:mmA" default-time="23:59:59"
              @change="confirm(-1)" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12">
          <el-form-item prop="dateRange">
            <el-date-picker v-model="pickers.dateRange"
              type="datetimerange" unlink-panels size="small"
              range-separator="～" :start-placeholder="$t('DateRangePicker.Start_Time')" :end-placeholder="$t('DateRangePicker.End_Time')"
              format="yyyy-MM-dd h:mmA" :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions" @change="confirm(-1)">
            </el-date-picker>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import { DatePicker, TimeSelect } from 'element-ui';
import moment from 'moment';

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect
  },
  name: 'date-range-picker',
  props: {
    from: Date,
    to: Date,
    shortcuts: {
      type: Array,
      default: () => {
        return [
          {
            label: this.$t('DateRangePicker.Today'),
            from: moment().startOf('day').toDate(),
            // to: new Date()
          },
          {
            label: this.$t('DateRangePicker.This_Week'),
            from: moment().startOf('isoWeek').toDate(),
            // to: new Date()
          },
          {
            label: this.$t('DateRangePicker.This_Month'),
            from: moment().startOf('month').toDate(),
            // to: new Date()
          }
        ]
      }
    },
    earliest: {
      type: Number,
      default: 0
    },
    useSplitPickers: {
      type: Boolean,
      default: false
    }
  },

  data() {
    let checkRangeValidity0 = (rule, value, callback) => {
      if (value[0] > moment().endOf('day').toDate()) callback(new Error(`${this.$t('DateRangePicker.Message.start_date_greater_than_today')}`));
      else if (value[1] > moment().endOf('day').toDate()) callback(new Error(`${this.$t('DateRangePicker.Message.start_date_greater_than_today')}`));
      else callback();
    };
    let checkRangeValidity1 = (rule, value, callback) => {
      if (value[0] > value[1]) callback(new Error(`${this.$t('DateRangePicker.Message.start_date_later_than_end_date')}`));
      else callback();
    };
    let earliest = this.earliest;

    return {
      pickers: {
        dateRange: [this.from, this.to]
      },
      shortcutIndex: -1,

      rules: {
        dateRange: [
          // {validator: checkRangeValidity0, trigger: 'change'},
          {validator: checkRangeValidity1, trigger: 'change'}
        ]
      },

      // Limit the selectable dates.
      pickerOptions: {
        disabledDate(date) {
          if (earliest > 0)
            return date < moment.unix(earliest).toDate();
          return false;
        }
      }
    };
  },

  methods: {
    confirm(_index) {
      let from, to;

      // console.log('confirm', _index);
      this.shortcutIndex = _index;//Could be -1, means "not set by shortcuts".

      // Set by one of the shortcuts.
      if (_index >= 0) {
        this.pickers.dateRange = [
          this.shortcuts[_index].from,
          this.shortcuts[_index].to || new Date()
        ];
      }
      from = this.pickers.dateRange[0];
      to = this.pickers.dateRange[1];

      // Emit on-change event to parent scope. NOTE: Check date-range validity first.
      this.$refs['pickersForm'].validate(valid => {
        if (!valid) return;
        this.$emit('on-change', [from, to]);
      });
    },

    isShortcutActive(_index) {
      return _index === this.shortcutIndex;
    },

    // // Public methods.
    // getDateRange() {
    //   return this.pickers.dateRange;
    // }
  }
}

</script>

<style scoped>
/* .el-date-editor.el-input {
  max-width: 240px !important;
} */
</style>